/**
 * Native (Capacitor) vs web platform helpers.
 * Mobile apps load bundled assets locally but call the production API over HTTPS.
 */

export function isNativeApp(): boolean {
  if (typeof window === 'undefined') return false
  const cap = (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor
  return cap?.isNativePlatform?.() === true
}

export function getApiBaseUrl(): string {
  const apiUrl = import.meta.env.VITE_API_URL as string | undefined

  if (isNativeApp()) {
    return apiUrl || 'https://gbsoftt.com'
  }

  if (import.meta.env.PROD) {
    return ''
  }

  return apiUrl || 'http://localhost:3001'
}

export function getWebSocketUrl(): string {
  const wsUrl = import.meta.env.VITE_WS_URL as string | undefined

  if (isNativeApp()) {
    return wsUrl || 'https://gbsoftt.com'
  }

  if (import.meta.env.PROD) {
    return '/'
  }

  return wsUrl || 'http://localhost:3001'
}
